import { render, staticRenderFns } from "./cdwriteam.vue?vue&type=template&id=6bdbd494&scoped=true&"
import script from "./cdwriteam.vue?vue&type=script&lang=js&"
export * from "./cdwriteam.vue?vue&type=script&lang=js&"
import style0 from "./cdwriteam.vue?vue&type=style&index=0&id=6bdbd494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdbd494",
  null
  
)

export default component.exports